import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button, Card, S } from '@shared/components';

import styles from './FallbackMessage.less';

function FallbackMessage({ youthCount, onGoToReports }) {
  return (
    <Card margin className={styles.card}>
      <div className={styles.messageWrapper}>
        <S size="2" bold colored>
          {youthCount == 0 ? (
            <FormattedMessage id="advancementReport.FallbackMessage.noAdvancementReports" />
          ) : (
            <FormattedMessage
              id="advancementReport.FallbackMessage.noAdvancementsForYouth"
              values={{ youthCount }}
            />
          )}
        </S>
      </div>
      <Button color="info" uppercase={false} onClick={onGoToReports}>
        <FormattedMessage id="advancementReport.FallbackMessage.viewPreviousReports" />
      </Button>
    </Card>
  );
}

FallbackMessage.propTypes = {
  youthCount: PropTypes.number.isRequired,
  onGoToReports: PropTypes.func.isRequired,
};

export default FallbackMessage;
